import {
  STORE_KEY_LANG,
  STORE_KEY_USER_LANG,
  storeGet,
  storeSet
} from 'mailup-react-helpers'
import { atom, selector } from 'recoil'

export const localeState = atom({
  key: 'localeState',
  default: storeGet(STORE_KEY_USER_LANG) || storeGet(STORE_KEY_LANG) || 'en'
})

export const localeSelector = selector({
  key: 'localeSelector',
  get: ({ get }) => {
    return get(localeState)
  },
  set: ({ set }, { lang, userLang }) => {
    userLang
      ? set(localeState, userLang.toLowerCase())
      : set(localeState, lang.toLowerCase())
    storeSet(STORE_KEY_LANG, lang.toLowerCase())
    userLang && storeSet(STORE_KEY_USER_LANG, userLang.toLowerCase())
  }
})
